import { useIsFocused } from '@react-navigation/native';
import React, { NamedExoticComponent } from 'react';
import { View } from 'react-native';
import ErrorBoundary from '../../v2BaseComponents/ErrorBoundary';

export type wrapInTabContentContainerOwnProps = { children: any };

export type wrapInTabContentContainerProps = wrapInTabContentContainerOwnProps;

const TabContentContainer: React.FC<wrapInTabContentContainerProps> = (props) => {
    const isFocused = useIsFocused();
    return (
        <View
            style={{
                flex: 1,
                width: '100%',
                height: '100%',
                // paddingTop: Platform.OS === 'web' ? undefined : headerHeight,
            }}
            testID={isFocused ? 'focused-screen-root' : 'hidden-screen-root'}
        >
            {props.children}
        </View>
    );
};

export default function wrapInTabContentContainer(Componet: NamedExoticComponent<any>) {
    return (props: any) => (
        <TabContentContainer>
            <ErrorBoundary>
                <Componet {...props} />
            </ErrorBoundary>
        </TabContentContainer>
    );
}
